export function addTrailingSlash(path: string) {
  return path.slice(-1) === '/' ? path : `${path}/`
}
